import React from "react";

/* Import Boostrap */
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

const Heading3 = ({ translate, props }) => {
      var heading = <h3>{ translate(props.title) }</h3>;
      if (typeof props.subtitle !== 'undefined') {
        var subheading = <strong className="subheading">{ translate(props.subtitle) }</strong>;
      }

      return (
        <span>
          {heading}
          {subheading}
        </span>
      )
}

const mapStateToProps = (state, ownProps) => {
  return {
    translate: getTranslate(state.locale),
    props: ownProps
  };
};

export default connect(mapStateToProps)(Heading3);


// WEBPACK FOOTER //
// ./src/components/titles/Heading3.js